import axios from '../../functions/axios';
import moment from 'moment';
import { useEffect, useState, useMemo } from 'react';
import leftArrow from '../../assets/images/selection_left.png';
import rightArrow from '../../assets/images/selection_right.png';
import editButton from '../../assets/images/editButton.png';
import style from './SoldCarriageList.module.css';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuthContext } from '../../hooks/useAuthContext';
import { parseDate } from '../../functions/functions';

export default function WeekView() {
  const location = useLocation();
  const [isLoading, setLoading] = useState(true);
  const [apiData, setApiData] = useState([]);
  const initDate = parseDate(Date.parse(location.state?.date || sessionStorage.getItem('selectedWeek') || new Date())).monday;
  const [currentDate, setCurrentDate] = useState(initDate);
  const navigate = useNavigate();
  const { user } = useAuthContext();
  const [searchQueryCarrier, setSearchQueryCarrier] = useState('');

  const setWeekDate = (date) => {
    const selectedDate = parseDate(date).monday;
    sessionStorage.setItem('selectedWeek', selectedDate);
    setCurrentDate(selectedDate);
  };

  const changeWeek = (offsetWeeks) => {
    const date = moment(currentDate).utc().add(offsetWeeks, 'week')
    setWeekDate(date);
  };
  const filteredData = useMemo(() => {
    return apiData
      .filter((soldCarriage) => {
        if (searchQueryCarrier === '') return true;
        return soldCarriage.carrier.replace(/\s+/g, '').toUpperCase().includes(searchQueryCarrier);
      })

  }, [apiData, searchQueryCarrier]);

  const carrierId = useMemo(() => {
    return [...new Set(filteredData.map((data) => data.carrier))].sort((...args) => {
      const [a, b] = args.map((carrier) => carrier.toUpperCase());
      return a.localeCompare(b, 'pl-PL', { sensitivity: 'base' });
    });
  }, [filteredData]);
  useEffect(() => {
    const source = axios.CancelToken.source();

    (async () => {
      if (!user) return null;
      setLoading(true);
      try {
        const { monday, sunday } = parseDate(currentDate);
        const response = await axios.get(`/soldCarriage`, {
          params: {
            startDate: monday,
            endDate: sunday,

          },
          cancelToken: source.token,
        });
        setApiData(response.data);
      } catch (error) {
        if (axios.isCancel(error)) {
          console.log('axios request canceled');
          return;
        }
        console.log(error);
      }
      setLoading(false);
    })();

    return () => {
      source.cancel();
    };
  }, [user, currentDate]);

  const weekDate = ['monday', 'sunday'].map((carriageDayStart) => new Date(parseDate(currentDate)[carriageDayStart]).toLocaleDateString('pl')).join(' - ');

  const navigation = (
    <div className={style.navigation}>
      <button className={`${style.addReport} btn btn-default`} onClick={navigate.bind(null, '/printSoldCarriage', { state: { searchQuery: searchQueryCarrier } })}>
        Drukuj
      </button>

      <p>{weekDate}</p>
      <img src={leftArrow} onClick={changeWeek.bind(null, -1)} alt='Arrow left' />
      <span className={style.weekNumber} onClick={() => setWeekDate(new Date())}>
        {parseDate(currentDate).week}
      </span>
      <img src={rightArrow} onClick={changeWeek.bind(null, 1)} alt='Arrow right' />
      <button className={`${style.addCarriage} btn btn-default`} onClick={navigate.bind(null, '/addSoldCarriage')}>
        Dodaj Wpis
      </button>
    </div>
  );

  if (isLoading || !apiData.length) {
    return (
      <>
        {navigation}
        {!apiData.length ? <div className={style.missingData}>Brak danych do wyświetlenia...</div> : null}
      </>
    );
  }


  return (
    <>
      <div className={style.container}>
        {navigation}
        <div className={style.filter}>
          {/* <label htmlFor='searchCar' style={{ margin: '10px' }}>Wyszukaj pojazd:</label>
                    <input
                        id='searchCar'
                        style={{ width: '130px', height: '22px' }}
                        type='search'
                        placeholder='Nr rejestracyjny'
                        onChange={handleFilterCars}
                    /> */}
          {/* </div>
        <div className={style.filter}> */}
          {/* <span style={{margin: '25px'}}>Wyszukaj kierowcę:</span>
          <input style={{width: '200px'}} type="search" className="form-control" placeholder="Nazwisko" onChange={(e) => handleFilterDrivers(e.target.value)}></input> */}
        </div>
        <div className={style.mainHeader}>
          <span>Przewoźnik</span>
          <span>Od kogo ładunek</span>
          <span>Trasa z/do</span>
          <span>Data załadunku</span>
          <span>Data rozładunku</span>
          <span>Stawka przewoźnika</span>
          <span>Stawka nasza</span>
          <span>Nr f-ry przewoźnika</span>
          <span>Nr f-ry nasz</span>
          {/* <span>Dokumenty</span> */}
          {/* <span>Status wykonania</span> */}
          <span>Edycja</span>
        </div>
        {carrierId
          .map((carrier) => (
            <div className={style.carWeek} key={carrier}>
              <div className={style.plate}>{carrier.toUpperCase()}</div>
              <div className={style.data}>
                {filteredData
                  .filter((soldCarriage) => soldCarriage.carrier === carrier)
                  .sort((...args) => {
                    const [a, b] = args.map(({ carriageDayStart }) => Date.parse(carriageDayStart));
                    return a - b;
                  })
                  .map((soldCarriage) => {
                    return (
                      <div className={style.carriageData} key={soldCarriage._id}>
                        {/* <div className={style.client}>{soldcarriage.carrier?.split(' ').reduce((acc, element) => [acc, <br />, element]) || '-'}</div> */}
                        <div className={style.client}>{soldCarriage.contractor || '-'}</div>
                        <div className={style.route}>
                          <ul className={style.routeList}>
                            <li className={style.routeStart}>{soldCarriage.routeStart || '-'}</li>
                            <li className={style.to}>{soldCarriage.routeEnd || '-'}</li>
                          </ul>
                        </div>
                        <div className={style.day}>
                          {new Date(soldCarriage.carriageDayStart).toLocaleDateString('pl')}
                        </div>
                        <div className={style.day}>
                          {new Date(soldCarriage.carriageDayStop).toLocaleDateString('pl')}
                        </div>
                        <div className={style.cost}>
                          {soldCarriage.carrierCost?.toLocaleString('pl-PL', { style: 'currency', currency: soldCarriage.currency || 'EUR' }) || '-'}
                        </div>
                        <div className={style.cost}>
                          {soldCarriage.contractorCost?.toLocaleString('pl-PL', { style: 'currency', currency: soldCarriage.currency || 'EUR' }) || '-'}
                        </div>
                        <div className={style.invoice}>{soldCarriage.carrierInvoice || '-'}</div>
                        <div className={style.invoice}>{soldCarriage.contractorInvoice || '-'}</div>
                        {/* <div className={style.doc}>{<input id='documentation' type='checkbox' name='documentation' checked={soldcarriage.documentation} onChange={() => {}} />}
                        </div> */}
                        <span>
                          <img className={style.editButton} src={editButton} onClick={() => navigate('/editSoldCarriage', { state: soldCarriage })} />
                        </span>
                      </div>
                    );
                  })
                  .reduce((acc, element) => [acc, <hr className={style.dimmed}/>, element])}
              </div>
            </div>
          ))}
      </div>
    </>
  );
}
